import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryInvalidCouponId extends AnnualSummaryError {
    promotionalCouponId;
    constructor(promotionalCouponId, options) {
        super('The Coupon ID is invalid', options);
        this.promotionalCouponId = promotionalCouponId;
    }
}
export default AnnualSummaryInvalidCouponId;
